import React, { useState } from "react";
import { newObjectiveId, Objective } from "../lib/objectives-store";

interface Props {
  onAdd: (objective: Objective) => void;
}

export default function AddObjectiveForm({ onAdd }: Props) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!title.trim()) return;
    onAdd({
      id: newObjectiveId(),
      title: title.trim(),
      detail: detail.trim(),
      timestampSec: null,
    });
    setTitle("");
    setDetail("");
    setOpen(false);
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full px-3 py-2 border border-dashed border-gray-700 hover:border-orange-500 text-sm text-gray-500 hover:text-orange-400 rounded transition"
      >
        + Add custom objective
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="p-3 rounded border border-gray-700 bg-gray-900 space-y-2">
      <input
        autoFocus
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Objective title..."
        className="w-full px-2 py-1 bg-gray-950 border border-gray-700 rounded text-sm text-white placeholder-gray-600"
      />
      <textarea
        value={detail}
        onChange={(e) => setDetail(e.target.value)}
        placeholder="Optional context"
        rows={2}
        className="w-full px-2 py-1 bg-gray-950 border border-gray-700 rounded text-xs text-gray-300 placeholder-gray-600"
      />
      <div className="flex gap-2 text-xs">
        <button
          type="submit"
          disabled={!title.trim()}
          className="px-2 py-1 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-700 disabled:cursor-not-allowed text-white rounded"
        >
          Add
        </button>
        <button
          type="button"
          onClick={() => {
            setOpen(false);
            setTitle("");
            setDetail("");
          }}
          className="px-2 py-1 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded"
        >
          Cancel
        </button>
      </div>
    </form>
  );
}
